export default __webpack_public_path__ + "static/media/Sudhakar.7f162b02.jpeg";